import { EventPayload } from '@wix/panorama-common-shared/types';
import { ReporterOptions } from './types';

export const nodeReporter =
  (url: string, { silent = false }: ReporterOptions = { silent: false }) =>
  (eventPayload: EventPayload): boolean => {
    const body = JSON.stringify({ logMessage: eventPayload });

    fetch(url, { method: 'POST', body })
      .then((res) => {
        if (res.ok || silent) {
          return;
        }

        console.error('Panorama report failed', res.statusText);
      })
      .catch((e) => {
        if (silent) {
          return;
        }

        console.error('Panorama report failed', e);
      });

    return true;
  };
